export default interface ICoBrowseDto {
  session: {
    id: string;
    type: string;
    sessionId: string;
    sessionJoinToken: string;
  };
  openOffer: boolean;
  event: null;
  control: {
    allowControl: boolean;
    offer: boolean;
  };
  navigation: {
    allowNavigation: boolean;
    offer: boolean;
    url: string;
  };
  drawing: {
    allowDrawing: boolean;
    offer: boolean;
  };
  loading: boolean;
}

export const initialCoBrowseObject: ICoBrowseDto = {
  session: {
    id: "",
    type: "",
    sessionId: "",
    sessionJoinToken: "",
  },
  openOffer: false,
  event: null,
  control: {
    allowControl: false,
    offer: false,
  },
  navigation: {
    allowNavigation: false,
    offer: false,
    url: "",
  },
  drawing: {
    allowDrawing: false,
    offer: false,
  },
  loading: false,
};
